/// <reference path="../../polaris-web-components.d.ts" />
import React from 'react';
import "../../custom.css";
export default function Dashboard() {
  var queryString = window.location.search;
  const supportLink = <s-link url="https://help.shopify.com/manual">fulfilling orders</s-link>
  const cards = [
    {
      title: 'Products',
      helpText: `
      Manage your products with CSV/Excel import/export,
      catalog mapping, currency conversion, and customizable export columns.
    `,
      route: '/products?' + queryString,
      image: '../assets/3129492.jpg'
    },
    {
      title: 'Collections',
      helpText: 'Efficiently manage collections with CSV/Excel import and export, bulk collection deletion, and metafield deletion support.',
      route: '/collections?' + queryString,
      image: '../assets/3129492.jpg'
    },
    {
      title: 'Customers',
      helpText: 'Easily manage customer data with CSV/Excel import and export, bulk customer deletion, and metafield deletion support.',
      route: '/customers?' + queryString,
      image: '../assets/1.png'
    },
    {
      title: 'Pages',
      helpText: 'Simplify page management with CSV/Excel import and export, bulk page deletion, metafield deletion support, and more.',
      route: '/pages?' + queryString,
      image: '../assets/3129492.jpg'
    },
    {
      title: 'Metaobjects',
      helpText: `Manage your metaobjects with 
      Export/Import metaobjects by definition type in CSV or Excel, catalog mapping and more.`,
      route: '/metaobjects?' + queryString,
      image: '../assets/2.png'
    },
    {
      title: 'Defiinitions',
      helpText: `Manage your metaobjects & metafield Definitions with 
      Export/Import  definitions in CSV or Excel, catalog mapping and more.`,
      route: '/definitions?' + queryString,
      image: '../assets/2.png'
    },
    // {
    //   title: 'Orders',
    //   helpText: 'Streamline order management with CSV/Excel import and export,catalog mapping, bulk order deletion, and metafield deletion support and more.',
    //   route: '/orders?' + queryString,
    //   image: '../assets/3.png'
    // },

    {
      title: 'Translations',
      helpText: 'Manage translations efficiently with Excel import and export, based on parent resources, catalog mapping and more.',
      route: '/translations?' + queryString,
      image: '../assets/3129492.jpg'
    },
    ,

    {
      title: 'Menu',
      helpText: 'Manage Menu Items efficiently with Excel import and export, based on parent resources, catalog mapping and more.',
      route: '/menu?' + queryString,
      image: '../assets/3129492.jpg'
    },


    {
      title: 'Plans',
      helpText: `
        7-day free trial to explore all premium features. Compare the features of our Free and Paid plans below and select the one that's right for you.
      `,
      route: '/plans?' + queryString,
      image: '../assets/3129492.jpg'
    },
    {
      title: 'Support & Privacy',
      helpText: (
        <>
          We're here to help. If you face issues with this app or found a bug, please let us know. You can email us at{' '}
          <s-link url="mailto:support@claritytechnologies.com" target='_blank'>support@claritytechnologies.com</s-link>.
        </>
      ),
      route: '/privacy',
      image: '../assets/4.png'
    }
  ];



  //   return (
  //     <Page title="Dashboard">
  //       <Layout>
  //         {cards.map((card, index) => (
  //           <Layout.Section key={index} oneHalf>
  //             <Card sectioned>
  //               <HorizontalStack align="center" gap="4">
  //                 <Box flex="1">
  //                   <Text as="h2" variant="headingSm">{card.title}</Text>
  //                   <Text as="p" variant="bodyMd">{card.helpText}</Text>
  //                   <Button onClick={() => navigate(card.route)}>Get Started</Button>
  //                 </Box>
  //                 <Thumbnail source={card.image} alt={card.title} />
  //               </HorizontalStack>
  //             </Card>
  //           </Layout.Section>
  //         ))}
  //       </Layout>
  //     </Page>
  //   );


  return (
    <s-page heading='Dashboard'>
      <s-box paddingBlockStart="base" paddingBlockEnd="base">
        <s-heading>Manage and monitor bulk operations for imports, exports.</s-heading>
      </s-box>
      <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="base">
        {cards.map((card, index) => (
          <s-grid-item gridColumn="span 6" gridRow="span 1">
            <s-section>
              <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="base">
                <s-grid-item gridColumn="span 8" gridRow="span 1">
              <s-heading>
                {card.title}
              </s-heading>
              <s-paragraph tone="success" color="subdued">
                {card.helpText}
              </s-paragraph>
              <s-box paddingBlockStart="base">
              <s-button
                variant="secondary"
                onClick={() => {
                  window.location.href = window.location.href.replace(window.location.pathname, card.route);
                }}
              >
                Get Started
              </s-button>
              </s-box>
              </s-grid-item>
              <s-grid-item gridColumn="span 4" gridRow="span 1">
              {/* <s-box inlineSize="300px"> */}
                <s-image
                  src={card.image}
                  alt={card.title}
                    aspectRatio="1/1"
                    objectFit="cover"
                    borderRadius="base"
                    inlineSize="fill"
                />
              {/* </s-box> */}
              </s-grid-item>
              
              </s-grid>
              
            </s-section>
            
          </s-grid-item>
        ))}
      </s-grid>
    </s-page>
  );
}
